module.exports = __webpack_public_path__ + "img/sdkImage.cc430f75.png";